import * as React from 'react';

const PrinterSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 7v10h4v4h12v-4h4V7H2zm19 9h-3v-4H6v4H3V8h18v8zM7 13h10v7H7v-7zM7 6V5h10v1h1V4H6v2z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M8 15h8v1H8zM8 17h8v1H8z" />
        </g>
    </svg>
);

PrinterSvg.displayName = 'PrinterSvg';
export default PrinterSvg;
